import React from 'react';
import PropTypes from 'prop-types';
import ArrowDropUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';

import kebabCase from 'lodash/kebabCase';
import classNames from 'classnames';

// TODO: a must be replaced with button and eslint ignore must be removed
/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
export default class LibraryTableHeader extends React.PureComponent {
  renderHeaders() {
    const {columns} = this.props;

    return <tr>{columns.map(columnName => this.renderHeader(columnName))}</tr>;
  }

  renderHeader(columnName) {
    const className = classNames(kebabCase(columnName));

    return (
      <th key={className} className={className}>
        {this.renderHeaderCellContents(columnName)}
      </th>
    );
  }

  renderHeaderCellContents(columnName) {
    const {sortableColumns, sortColumn} = this.props;

    if (!sortableColumns.includes(columnName)) {
      return <span>{columnName}</span>;
    }

    if (columnName === sortColumn) {
      const sortIcon = this.sortIcon();

      return (
        <a href="#" onClick={e => this.handleClick(columnName, e)}>
          {columnName}
          {sortIcon}
        </a>
      );
    }

    return (
      <a href="#" onClick={e => this.handleClick(columnName, e)}>
        {columnName}
      </a>
    );
  }

  sortIcon() {
    const {sortDirection} = this.props;

    if (sortDirection === 'up') {
      return <ArrowDropUp />;
    }

    return <ArrowDropDown />;
  }

  handleClick(columnName, e) {
    const {onSort} = this.props;

    e.preventDefault();
    onSort(columnName);
  }

  render() {
    return <thead>{this.renderHeaders()}</thead>;
  }
}

LibraryTableHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  sortableColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  sortColumn: PropTypes.string.isRequired,
  sortDirection: PropTypes.oneOf(['up', 'down']).isRequired,
  onSort: PropTypes.func.isRequired,
};

LibraryTableHeader.defaultProps = {
  onSort: () => {},
};

LibraryTableHeader.displayName = 'LibraryTableHeader';
